module.exports = __webpack_public_path__ + "img/leaf.0456f2cb.svg";